// Configuración de seguridad de la tienda
// IMPORTANTE: Solo modificar estos valores si es necesario

// Email del único administrador autorizado
export const ADMIN_EMAIL = "contactmaxi531@gmail.com";

// Verificar si un usuario es administrador
export const isAdminUser = (user) => {
  if (!user || !user.email) return false;
  return user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase();
};

// Verificar si el usuario actual está autenticado
export const isAuthenticated = (user) => {
  return user !== null && user !== undefined;
};

// Rutas protegidas solo para admin
export const ADMIN_ROUTES = [
  '/admin',
  '/astericimg',
];

// Rutas que requieren autenticación
export const AUTH_ROUTES = [
  '/carrito',
  '/checkout',
];
